import { render, staticRenderFns } from "./AcceptRejectRequest.vue?vue&type=template&id=ecf51212&scoped=true"
import script from "./AcceptRejectRequest.vue?vue&type=script&lang=js"
export * from "./AcceptRejectRequest.vue?vue&type=script&lang=js"
import style0 from "./AcceptRejectRequest.vue?vue&type=style&index=0&id=ecf51212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf51212",
  null
  
)

export default component.exports